<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Editar Alergia</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="4" md="6">
              <v-text-field
                v-model="alergia"
                prepend-icon="mdi-account"
                label="Alergia *"
                maxlength="100"
                :rules="requiredRules"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="6">
              <v-text-field
                v-model="observaciones"
                prepend-icon="mdi-account"
                label="Observaciones"
                maxlength="200"
                dense
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="modificarAlergia"
            >Guardar</v-btn
          >

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "../../axios-auth.js";

export default {
  data: (vm) => ({
    alergia: null,
    observaciones: null,
    idPaciente: null,
    lazy: false,
    valid: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
  }),

  props: ["visible", "idAlergiaPaciente"],

  computed: {
    show: {
      get() {
        if (this.visible) this.buscarDatosAlergia();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    buscarDatosAlergia() {
      const idAlergiaPaciente = this.idAlergiaPaciente;
      let self = this;

      axios
        .get("/Paciente/BuscarDatosAlergia?", {
          params: {
            idAlergiaPaciente: this.idAlergiaPaciente,
          },
        })
        .then((response) => {
          self.alergia = response.data.alergia;
          self.observaciones = response.data.observaciones;
          self.idPaciente = response.data.idPaciente;
        })
        .catch((error) => {});
    },
    modificarAlergia() {
      this.$swal({
        title: "Modificar Alergia",
        text: "¿Desea modificar los datos de la alergia?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosAlergia = {
            alergia: this.alergia,
            observaciones: this.observaciones,
            idPaciente: this.idPaciente,
            idAlergiaPaciente: this.idAlergiaPaciente,
          };
          let self = this;
          axios
            .post("/Paciente/ModificarAlergia", datosAlergia)
            .then((response) => {
              self.$refs.form.resetValidation();

              document.getElementsByClassName(
                "v-dialog--active"
              )[0].scrollTop = 0;
              self.showAlert({
                icon: "success",
                title: "Datos de la alergia modificados exitosamente",
                vm: self,
              });
              self.$emit("alergiaModificada");
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "Los datos de la alergia no pudieron ser modificados",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
